import { Box, Layers, Cpu } from "lucide-react";

export interface Pillar {
  id: string;
  title: string;
  link: string;
  description: string;
  icon: React.ComponentType<{ size?: number; style?: React.CSSProperties }>;
  accent: string;
  accentRgb: string;
  tag: string;
}

export const pillars: Pillar[] = [
  {
    id: "01",
    title: "Animation Studio",
    link: "/services/3d-animation",
    description:
      "KIVAS transforms ideas into stunning visual experiences — producing high-impact 3D content for screens of every scale, from social feeds to stadium facades. Cinematic environments and real-time animations that bring digital spaces to life with unprecedented realism.",
    icon: Box,
    accent: "#6366f1",
    accentRgb: "99, 102, 241",
    tag: "Immersive Content",
  },
  {
    id: "02",
    title: "Technology",
    link: "/services/ar-vr",
    description:
      "Every extraordinary experience demands an extraordinary foundation. KIVAS deploys and integrates premium display and interactive hardware — the physical infrastructure that brings every visual, digital, and immersive experience to life.",
    icon: Layers,
    accent: "#a855f7",
    accentRgb: "168, 85, 247",
    tag: "AR / VR / XR",
  },
  {
    id: "03",
    title: "Hardware Solutions",
    link: "/services/hardware",
    description:
      "Custom hardware design and integration, bridging the gap between software intelligence and physical execution. Precision-built systems that power the most demanding immersive installations in the world.",
    icon: Cpu,
    accent: "#ec4899",
    accentRgb: "236, 72, 153",
    tag: "Physical Layer",
  },
];
